import classNames from 'classnames';
import { useAtomValue } from 'jotai';

import { casePresentationModeAtom } from '../casePresentation/atoms';
import type { ImageObject } from '../types';

import { AnnotationControls } from './annotationControls';
import { FindingsToggles } from './findingsToggles';
import { ImageQualityFindingsToggle } from './ImageQualityFindingsToggle';
import { ViewModeToggles } from './viewModeToggles';

interface Props {
  activeImage?: ImageObject;
  onChangeViewerMode: (mode: number) => void;
  onSetShouldPersistUserModifications: (value: boolean) => void;
}

export const ImageToolbar = ({
  activeImage,
  onChangeViewerMode,
  onSetShouldPersistUserModifications,
}: Props) => {
  const showCasePresentation = useAtomValue(casePresentationModeAtom);

  if (showCasePresentation) {
    return null;
  }

  return (
    <div
      data-testid="image-toolbar"
      className={classNames(
        'vai-rounded-sm vai-h-fit vai-w-fit vai-flex vai-flex-col vai-items-center vai-justify-center vai-absolute vai-left-3 vai-top-1/2 vai-transform vai--translate-y-1/2 vai-z-[200] vai-transition-all vai-duration-200 vai-gap-1 vai-p-1',
      )}
    >
      <ViewModeToggles />
      <FindingsToggles
        activeImage={activeImage}
        setShouldPersistUserModifications={onSetShouldPersistUserModifications}
        onChangeViewerMode={onChangeViewerMode}
      />
      <AnnotationControls />
      <ImageQualityFindingsToggle />
    </div>
  );
};
